import { render, staticRenderFns } from "./RouteTemplatesTransport.vue?vue&type=template&id=f83340c2&"
import script from "./RouteTemplatesTransport.vue?vue&type=script&lang=js&"
export * from "./RouteTemplatesTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports